export function appendScopeToStyle(style: string, selector: string): string {
    // In dev mode, sometimes we have selectors that are immediately preceded by a comment
    // Since the regex on the next line starts matching from the * character,
    // and stops at the next {, it reads past the comment terminator and the
    // selector is ignored from the scope.
    /// Example:
    /// /* foo */
    //  .container { }
    // In this case, .container will not be scoped.
    // because the regex thinks that the rule name is "* foo */ .container"
    // so it would output  /[data-block="foo"] foo */ .container
    //
    // This wasn't a problem previously because:
    // 1. Comments were stripped out by webpack in a published app
    // 2. In the studio, each block used to be in its own iframe, so there was
    //    no chance of selectors from one block affecting another.
    // This is technically only required when running the blocks locally.
    // I'm still putting it here to save some debugging time in the future.
    let stylesContent = stripComments(style);

    const pattern = re(
        /[@\w*#.:]/, // @, word, *, #, . or :
        /[^{}]+/, // everything except from braces
        /{/g, // opening brace
    );
    stylesContent = stylesContent.replace(pattern, (match) => {
        if (match[0] === "@") return match;
        if (match[0] === "*" && match[1] === "!") return match;
        if (match.indexOf("from") === 0 || match.indexOf("to") === 0) return match;
        if (match[0].match(/\d/)) return match;
        return match
            .split(",")
            .map((s) => `${selector} ${s}`)
            .join(",");
    });

    return stylesContent;
}
/**
 * Concatenate regexes for easier reading.
 * Can pass in strings to match directly instead of having to
 * manually escape them
 * e.g.
 * regexConcat(/foo/, "/", /baz/) // eqivalent to /foo\/baz/
 * // matches foo/baz. Notice that / is not escaped because it's a string literal.
 */
function re(...rxs: (RegExp | string)[]) {
    const last = rxs[rxs.length - 1];
    return new RegExp(rxs.map((rx) => reSource(rx)).join(""), last instanceof RegExp ? last.flags : undefined);
}
function reSource(r: RegExp | string): string {
    return r instanceof RegExp ? r.source : r;
}

function stripComments(style: string) {
    let inComment = false;
    let result = "";
    for (let i = 0; i < style.length; i++) {
        if (style[i] === "/" && style[i + 1] === "*") {
            inComment = true;
            i++;
            continue;
        }
        if (style[i] === "*" && style[i + 1] === "/") {
            inComment = false;
            i++;
            continue;
        }
        if (!inComment) {
            result += style[i];
        }
    }
    return result;
}
